"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
var smallLogo40_1 = require("./smallLogo40");
var smallLogo52_1 = require("./smallLogo52");
exports.Logo = {
    SmallLogo40: smallLogo40_1.SmallLogo40,
    SmallLogo52: smallLogo52_1.SmallLogo52,
};
